// export const baseurlvmkp='/vmkp/api'

export const baseurlvmkp='/vmkp/api'
// export const baseurlvmkp='http://192.168.1.217:8080/api'
export const baseexcel='/vmkp1/'
export const loadingcherker = (value) => {
    return value ? value : false;
  };
// /vmkp/
// https://vmkgserver.in:8443